var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monthly-report"},[_c('div',{ref:"chart",style:({ width: '100%', height: _vm.height + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }